import { DataSource, Layout, Panel, Splitter, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDeliveryReceipt extends Layout {
    panelContactInfo: Panel;
    panelPDF: Panel;
    sourceSendDeliveryReceipt: DataSource;
    splitter2: Splitter;
    textboxComment: Textbox;
    textboxContactName: Textbox;
    textboxEmail: Textbox;
    textboxSubject: Textbox;
    textboxTemplate: Textbox;
}
